// src/components/products/ProductForm/TourDetailsSections/TourBasicInfoSection.jsx

import React from "react";
import { Grid, Typography, RadioGroup, FormControlLabel, Radio } from "@mui/material";
import FormInput from "../../../inputs/FormInput";

const TourBasicInfoSection = ({
    formData,
    setFormData,
    errors,
    isArabic,
    packagesOptions,
    loadingPackages,
    tourType,
    handleTourTypeChange,
}) => {
    return (
        <Grid container spacing={3}>
            {/* Package Selection */}
            <Grid item xs={12} md={6}>
                <FormInput
                    label={isArabic ? 'الباقة' : 'Package'}
                    type="select"
                    name="package_id"
                    value={formData.package_id || ''}
                    onChange={(e) => setFormData({
                        ...formData,
                        package_id: e.target.value
                    })}
                    required
                    error={!!errors.package_id}
                    helperText={errors.package_id}
                    disabled={loadingPackages}
                    options={packagesOptions}
                />
            </Grid>

            {/* Tour Type Selection */}
            <Grid item xs={12} md={6}>
                <Typography variant="subtitle2" sx={{ mb: 1 }}>
                    {isArabic ? 'نوع الجولة' : 'Tour Type'}
                    <span style={{ color: 'red' }}> *</span>
                </Typography>
                <RadioGroup
                    row
                    value={tourType}
                    onChange={handleTourTypeChange}
                >
                    <FormControlLabel
                        value="default"
                        control={<Radio />}
                        label={isArabic ? 'افتراضي' : 'Default'}
                    />
                    <FormControlLabel
                        value="morning_and_evening"
                        control={<Radio />}
                        label={isArabic ? 'صباحي ومسائي' : 'Morning & Evening'}
                    />
                </RadioGroup>
            </Grid>
        </Grid>
    );
};

export default TourBasicInfoSection;
